// import React, { useState } from "react";
// import { useParams, Link } from "react-router-dom";

// const CategoryDetails = () => {
//   const { id } = useParams();
//   const [selectedItem, setSelectedItem] = useState(null);
//   // Map of category titles
//   const categoryTitles = {
//     1: "Chef's Special Platter",
//     2: "Crispy Delight Platter",
//     3: "Masala Fusion Platter",
//     4: "Crispy Delights",
//     5: "Hangout Platter - Masala Twist",
//     6: "Tasty Bites - Fried Special",
//     7: "Chill Plate - Spicy",
//     8: "Hangout Platter - Fried Fun",
//     9: "Chill Plate - Crispy",
//     10: "Tasty Bites - Masala Mix",
//     11: "Chefs Special - Soup with Crispy",
//     12: "Juice",
//     13: "Drinks and Beverages",
//     14: "Tea and Coffee",
//     55: "Ice Cream",
//   };

//   const categoryTitle = categoryTitles[id] || "Category";

//   // Dummy details for each category
//   const menuItems = {
//     1: [
//       {
//         title: "Egg Fired Rice",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721902/common_egg_fried_rice-min_z4kinc.jpg",
//         description: "Grilled bread with tomatoes and basil.",
//       },
//       {
//         title: "Chicken Lollipop",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721905/csp_chicken_lollipop-min_f7tirm.jpg",
//         description: "Crispy rolls with veggies.",
//       },
//       {
//         title: "Garlic Mashroom",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721904/csp_garlic_mushroom-min_bddv6b.jpg",
//         description: "Crispy rolls with veggies.",
//       },
//       {
//         title: "Vegetable Stir Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721904/csp_vegetable_stir_fry-min_zunbnf.jpg",
//         description: "Crispy rolls with veggies.",
//       },
//       {
//         title: "Drinks",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_drinks-min_av5u0n.jpg",
//         description: "Crispy rolls with veggies.",
//       },
//     ],
//     2: [
//       {
//         title: "Egg Fired Rice",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721902/common_egg_fried_rice-min_z4kinc.jpg",
//         description: "Grilled steak with sauce.",
//       },
//       {
//         title: "Chinese Vegetables",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721901/common_chinese_vegetables-min_mvjfik.jpg",
//         description: "Salmon with lemon butter.",
//       },
//       {
//         title: "Fried Chicken",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_fried_chicken-min_cvjtvj.jpg",
//         description: "Salmon with lemon butter.",
//       },
//       {
//         title: "Drinks",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_drinks-min_av5u0n.jpg",
//         description: "Salmon with lemon butter.",
//       },
//     ],
//     3: [
//       {
//         title: "Masala Chicken",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/mfp_masala_chicken-min_icwkd5.jpg",
//         description: "Rich mushroom soup.",
//       },
//       {
//         title: "Chicken Fired Rice",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721899/mfp_chicken_fried_rice-min_ahkxy6.png",
//         description: "Grilled steak with sauce.",
//       },
//       {
//         title: "Chinese Vegetables",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721901/common_chinese_vegetables-min_mvjfik.jpg",
//         description: "Salmon with lemon butter.",
//       },
//       {
//         title: "Salad",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_salad-min_udykml.jpg",
//         description: "Creamy tomato soup.",
//       },
//       {
//         title: "Drinks (Can)",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721901/common_drinks_can-min_wgf5lc.jpg",
//         description: "Creamy tomato soup.",
//       },
//     ],
//     4: [
//       {
//         title: "Chicken Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_fried_chicken-min_cvjtvj.jpg",
//         description: "Classic Caesar salad.",
//       },
//       {
//         title: "Chicken Crumb",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721901/common_chicken_crumb-min_rzfbnh.jpg",
//         description: "Fresh veggies and feta.",
//       },
//       {
//         title: "Chicken Nugget",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/common_chicken_nugget-min_rjbljq.jpg",
//         description: "Fresh veggies and feta.",
//       },
//       {
//         title: "Chicken Onthon",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721898/cd_chicken_onthon-min_e98cr6.jpg",
//         description: "Fresh veggies and feta.",
//       },
//       {
//         title: "Chicken Singara",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/common_chicken_singara-min_cbkikb.jpg",
//         description: "Fresh veggies and feta.",
//       },
//       {
//         title: "French Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_french_fry-min_wgvvg5.jpg",
//         description: "Fresh veggies and feta.",
//       },
//     ],
//     5: [
//       {
//         title: "Chicken Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_fried_chicken-min_cvjtvj.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Chicken Singara",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/common_chicken_singara-min_cbkikb.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     6: [
//       {
//         title: "Chicken Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_fried_chicken-min_cvjtvj.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Chicken Samosa",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721899/common_chicken_samosa-min_b0lsbu.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     7: [
//       {
//         title: "Chicken Nugget",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/common_chicken_nugget-min_rjbljq.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Chicken Samosa",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721899/common_chicken_samosa-min_b0lsbu.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "French Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_french_fry-min_wgvvg5.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     8: [
//       {
//         title: "Chicken Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_fried_chicken-min_cvjtvj.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "French Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_french_fry-min_wgvvg5.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     9: [
//       {
//         title: "Chicken Crumb",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721901/common_chicken_crumb-min_rzfbnh.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Chicken Samosa",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721899/common_chicken_samosa-min_b0lsbu.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     10: [
//       {
//         title: "Chicken Fry",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/common_fried_chicken-min_cvjtvj.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Chicken Samosa",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721899/common_chicken_samosa-min_b0lsbu.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Chicken Singara",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/common_chicken_singara-min_cbkikb.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     11: [
//       {
//         title: "Sea Food Clear Soup",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721906/csswc_sea-food_clear_soup-min_xfsh8c.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Potato Wedges",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721906/csswc_potato_wedges-min_zwnznk.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     12: [
//       {
//         title: "Apple",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721908/juice_apple-min_ctx7is.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Orange",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721908/juice_orange-min_kk9hrt.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Pineapple",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/juice_pineapple-min_fxhbts.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Malta",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721910/juice_malta-min_x0bgqc.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     13: [
//       {
//         title: "Coca Cola",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721905/drinks_cocacola-min_ijlrea.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Sprite",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758722781/drinks_sprite_nxs1e0.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Fanta",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721905/drinks_fanta-min_l3el3i.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Mineral Water",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721906/drinks_mineral_water-min_vasbp7.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Lemonade",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721905/drinks_lemonade-min_m8j1st.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     14: [
//       {
//         title: "Espresso Cappuccino Coffee",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721902/tc_espresso_cappuccino_coffee-min_jc7bou.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Black Cofee",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721900/tc_black_coffee-min_rrj9h6.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Cold Coffee",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721902/tc_cold_coffee-min_d0rn28.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Coffee Regular",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721901/tc_coffee_regular-min_nwi4in.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Milk Tea",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721902/tc_milk_tea-min_qxahjp.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Raw Tea",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721903/tc_raw_tea-min_lrtenr.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//     15: [
//       {
//         title: "Vanilla Falvour",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721908/ic_vanilla_falvour-min_qncxwn.jpg",
//         description: "Decadent chocolate cake.",
//       },
//       {
//         title: "Chocolate Falvour",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721906/ic_chocolate_flavour-min_hvbsvw.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Strawberry Falvour",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721909/ic_strawberry_flavour-min_vivljd.jpg",
//         description: "Assorted ice creams.",
//       },
//       {
//         title: "Combo Twist Regular",
//         image:
//           "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758721906/ic_combo_twist_regular-min_uhsppp.jpg",
//         description: "Assorted ice creams.",
//       },
//     ],
//   };

//   const items = menuItems[id] || [];

//   return (
//     <div className="bg-[#fffdf6] min-h-screen py-12 px-4 md:px-20 relative">
//       <Link
//         to="/restaurant"
//         className="text-lime-500 font-bold mb-6 inline-block"
//       >
//         ← Back to Restaurant
//       </Link>
//       <h1 className="text-3xl sm:text-4xl font-bold text-center mb-12 uppercase">
//         {categoryTitle}
//       </h1>

//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//         {items.map((item, idx) => (
//           <div
//             key={idx}
//             className="bg-white shadow-lg rounded-2xl p-4 cursor-pointer hover:shadow-xl transition"
//             onClick={() => setSelectedItem(item)}
//           >
//             <img
//               src={item.image}
//               alt={item.title}
//               className="w-full h-40 sm:h-48 object-cover rounded-lg mb-4"
//             />
//             <h2 className="text-xl font-semibold mb-2">{item.title}</h2>
//             {/* <p className="text-gray-700 line-clamp-2">{item.description}</p> */}
//           </div>
//         ))}
//       </div>

//       {/* Modal */}
//       {selectedItem && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
//           onClick={() => setSelectedItem(null)}
//         >
//           <div
//             className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full overflow-hidden relative"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-4 right-4 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300 transition"
//               onClick={() => setSelectedItem(null)}
//             >
//               ✕
//             </button>
//             <img
//               src={selectedItem.image}
//               alt={selectedItem.title}
//               className="w-full h-64 sm:h-80 object-cover"
//             />
//             <div className="p-6">
//               <h2 className="text-2xl font-bold mb-4">{selectedItem.title}</h2>
//               {/* <p className="text-gray-700">{selectedItem.description}</p> */}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CategoryDetails;

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api/axiosInstance";

const CategoryDetails = () => {
  const { id } = useParams();
  const [menuItems, setMenuItems] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const [menuRes, catRes] = await Promise.all([
          api.get(`/restaurant/menu/get/category/${id}`),
          api.get(`/restaurant/categories/get/by-id/${id}`),
        ]);
        setMenuItems(menuRes.data);
        setCategory(catRes.data);
      } catch (err) {
        console.error("Error loading menu:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchMenuData();
  }, [id]);

  if (loading)
    return <p className="text-center text-gray-600 mt-10">Loading items...</p>;

  return (
    <div className="bg-[#fffdf6] min-h-screen py-12 px-4 md:px-20 relative">
      <Link
        to="/restaurant"
        className="text-lime-600 hover:underline font-semibold mb-6 inline-block"
      >
        ← Back to Restaurant
      </Link>

      <h1 className="text-3xl md:text-4xl font-bold text-center mb-10">
        {category?.title || "Category"}
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-xl transition cursor-pointer"
            onClick={() => setSelectedItem(item)}
          >
            <img
              src={item.imageUrl}
              alt={item.title}
              className="w-full h-56 object-cover"
            />
            <div className="p-4">
              <h3 className="text-lg font-bold">{item.title}</h3>
              <p className="text-gray-600 text-sm">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedItem && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedItem(null)}
        >
          <div
            className="relative bg-white p-4 rounded-2xl shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
              onClick={() => setSelectedItem(null)}
            >
              ✕
            </button>
            <img
              src={selectedItem.imageUrl}
              alt={selectedItem.title}
              className="max-w-[90vw] max-h-[80vh] rounded-lg"
            />
            <h2 className="text-xl font-bold mt-4">{selectedItem.title}</h2>
            <p className="text-gray-600 mt-2">{selectedItem.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryDetails;
